/**
 *
 * @param error
 * @returns {{message: string, errorCode: number}}
 */
const catchError = (error) => {
    console.error(error); // 输出错误内容
    let {errorCode, message} = error;
    if (!errorCode) {
        errorCode = 500;
    }
    if (!message) {
        message = '未知错误。';
    }
    return {message, errorCode};
}

/**
 *
 * @param error
 * @returns {{showToast: boolean, message: string, errorCode: number}}
 */
const showErrorToast = (error) => {
    const convertError = catchError(error);
    return {...convertError, showToast: true};
}

export {catchError, showErrorToast};